import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'src/app/shared/configurations/configurations.factory';
import { Configurations } from 'src/app/shared/configurations/models/configurations.model';
import { LoginResponceDto } from '../DTOs/login-response.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: HttpClient) {
    this.baseUrl = config.environmentConfig.portoSecureApiBaseUrl + '/api/Auth'
  }

  login$(username: string, password: string) {
    return this.httpClient.post<LoginResponceDto>(this.baseUrl + `/login`, {
      username: username,
      password: password
    })
  }
}
